import * as apis from '.'
import { EventBus } from 'vtils'

export const apiBus = new EventBus<{
  requestSuccess: (apiName: keyof typeof apis) => any
}>()
